import { useSearchParams } from "react-router-dom"
import { useDrawingKeywordsConfig } from "hooks/api/drawings/drawings.hook"
import { FileInfoKeywords } from "../../../FileInfoKeywords/FileInfoKeywords"
import type { TDrawingStatusProps } from "types/drawer.type"

export const ConfigurationDrawingKeywords = ({ drawingStatus }: TDrawingStatusProps) => {
	const [searchParams] = useSearchParams()

	const drawingId = Number(searchParams.get("drawingID"))
	const processingId = Number(searchParams.get("processingID"))

	const {
		data: drawingKeywords,
		isPending: isKeywordsPending,
		isError: errorFetchingKewords,
	} = useDrawingKeywordsConfig(drawingId, processingId, drawingStatus)

	return (
		<FileInfoKeywords
			drawingKeywords={drawingKeywords}
			isKeywordsPending={isKeywordsPending}
			errorFetchingKewords={errorFetchingKewords}
		/>
	)
}
